// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__qifsW","colMin":"styles_colMin__1fZD7","colCheckbox":"styles_colCheckbox__3ah8W"};